import React, { useMemo } from "react"
import { prettyNum } from "../../../../utils/prettyNum"
import { ListItem } from "../styles"
import { useGetGameByIdQuery } from "../../../../api/games"

interface ReportsListItemProps {
    cursor?: string
    id: number
    name?: string | undefined
    win?: string | undefined
    bet?: string | undefined
    count?: string | undefined
    payout?: string | undefined
    total?: boolean | undefined
    setSelectedHall?: (id: number) => void
}

const Item: React.FC<ReportsListItemProps> = ({
    id,
    win,
    bet,
    count,
    setSelectedHall,
    cursor
}) => {
    const outPercent = useMemo(() => bet && win && Number(win) === 0 && Number(bet) > 0 ? 100
        : ((Number(win) / 100 / (Number(bet) / 100)) * 100)?.toFixed(2), [win, bet]);
    const payout = useMemo(() => outPercent === "Infinity" ? "∞" : (outPercent !== "NaN" ? outPercent : "0") + "%", [outPercent]);
    const { data } = useGetGameByIdQuery(id);
    return (
        <ListItem bg={"#fff"} onClick={() => setSelectedHall && setSelectedHall(id)} cursor={cursor ? cursor : ""}>
            <div>{data?.name ?? `#${id}`}</div>
            <div>{prettyNum(Number(bet))}</div>
            <div>{prettyNum(Number(win))}</div>
            <div>{count}</div>
            <div>{prettyNum(Number(bet) - Number(win))}</div>
            <div>{payout}</div>
        </ListItem>
    )
}

export default Item
